import { Helmet } from 'react-helmet-async';


const HelmetTitle = () => {

  return (
    <Helmet>
      <title>🔬 AI Assistant - Étudiez avec l'IA | المساعد الذكي للدراسة</title>
      <meta
        name="description"
        content="Découvrez l'Assistant IA pour apprendre et réviser vos leçons en toute autonomie. Disponible en Arabe, Darija et Français." />
    </Helmet>
  );
}

export default HelmetTitle;
